<app-accounts-layout [isAdmin]="true" [menuList]="menuList"></app-accounts-layout>